import { render, staticRenderFns } from "./PollingButtonDoc.vue?vue&type=template&id=37144cbe&"
import script from "./PollingButtonDoc.vue?vue&type=script&lang=js&"
export * from "./PollingButtonDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports